import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Icon } from '@discretize/gw2-ui-new'
import React from 'react'
import { Skill } from '.'

const useStyles = makeStyles()((theme) => ({
  legends: {
    padding: theme.spacing(1),
  },
}))

function Legends({ legend1Id, legend2Id }) {
  const { classes } = useStyles()
  const legends = legend1Id && legend2Id && (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item className={classes.legends}>
        <Skill id={legend1Id} disableText size="big" />
      </Grid>
      <Icon name="WeaponSwap" style={{ verticalAlign: 'text-bottom' }} />
      <Grid item className={classes.legends}>
        <Skill id={legend2Id} disableText size="big" />
      </Grid>
    </Grid>
  )

  return legends
}

export default Legends
